module.exports = "/packs/images/our-perspective/hero@2x-d17b9c7843a52a928c61b136a92a1189.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/our-perspective/hero@2x.jpg
// module id = 1787
// module chunks = 0